module.exports = __webpack_public_path__ + "img/3-01-18-facility-safety.9b29a7b8.svg";